import Vue from "vue";
import VueRouter from "vue-router";
import { authRoutes } from "@/routes/auth.router";
import { challengerRoutes } from "@/routes/challenges.router";
import { categoriesRouter } from "./routes/categories.router";
import { profileRoutes } from "@/routes/profile.router";
import { configRoutes } from "@/routes/config.router";
import { leagueState } from "./utils/store-acessor";
import { impactBoardMembersState } from "./utils/store-acessor";
import { noop } from "rxjs";
import CertificateToPrint from "@/views/CertificateToPrint.vue";

Vue.use(VueRouter);

const LazyHome = () => import(/* webpackChunkName: "home" */ "./views/Home.vue");

const LazyChallenger = () => import(/* webpackChunkName: "challenges" */ "./views/ChallengerPage.vue");

const LazyCategories = () => import(/* webpackChunkName: "categories" */ "./views/CategoriesPage.vue");

const LazyAuth = () => import(/* webpackChunkName: "auth" */ "./views/auth/AuthPage.vue");

const LazyTheLeague = () => import(/* webpackChunkName: "the-league" */ "./views/TheLeaguePage.vue");

const LazyTheLeagueProfile = () => import(/* webpackChunkName: "the-league-profile" */ "./views/TheLeagueProfile.vue");

const LazyPrivacyPolicy = () => import(/* webpackChunkName: "the-league" */ "./views/PrivacyPolicy.vue");

const LazyTermsOfUse = () => import(/* webpackChunkName: "the-league" */ "./views/TermsOfUse.vue");

const LazyProfile = () => import(/* webpackChunkName: "PROFILE" */ "./views/profile/ProfileIndexPage.vue");

const LazyConfig = () => import(/* webpackChunkName: "PROFILE" */ "./views/profile/ProfileConfigPage.vue");

const LazyContactUs = () => import(/* webpackChunkName: "PROFILE" */ "./views/ContactUsPage.vue");

const LazyFaq = () => import(/* webpackChunkName: "FAQ" */ "./views/FaqPage.vue");

const LazyHomeAbout = () => import(/* webpackChunkName: "ABOUT" */ "./views/AboutNew.vue");

const LazyImpactBoard = () => import(/* webpackChunkName: "IMPACT-BOARD" */ "./views/ImpactBoard.vue");

const LazyVerifyCertificate = () =>
  import(/* webpackChunkName: "VERIFY-CERTIFICATE" */ "./views/VerifyCertificate.vue");

const LazyPageNotFound = () => import(/* webpackChunkName: "PROFILE" */ "./views/PageNotFound.vue");

const LazySearchResults = () => import(/* webpackChunkName: "SEARCH-RESULTS" */ "./views/SearchResults.vue");

const LazyESic = () => import(/* webpackChunkName: "E-SIC" */ "./views/ESic.vue");

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash };
    }
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: "/",
      name: "home",
      component: LazyHome
    },
    {
      path: "/challenges",
      component: LazyChallenger,
      name: "challenges",
      children: challengerRoutes,
      props: true
    },
    {
      path: "/desafios",
      redirect: "/challenges/in-progress"
    },
    {
      path: "/auth",
      component: LazyAuth,
      children: authRoutes
    },
    {
      path: "/the-league",
      name: "the-league",
      component: LazyTheLeague,
      beforeEnter: (to, from, next) => {
        leagueState.fetchLeague();
        next();
      }
    },
    {
      path: "/the-league-profile/:id",
      name: "the-league-profile",
      component: LazyTheLeagueProfile
    },
    {
      path: "/privacy-policy",
      name: "privacy-policy",
      component: LazyPrivacyPolicy
    },
    {
      path: "/terms-of-use",
      name: "terms-of-use",
      component: LazyTermsOfUse
    },
    {
      path: "/categories",
      component: LazyCategories,
      children: categoriesRouter
    },
    {
      path: "/profile",
      name: "user-profile",
      component: LazyProfile,
      children: profileRoutes
    },
    {
      path: "/config",
      name: "user-config",
      component: LazyConfig,
      children: configRoutes
    },
    {
      path: "/contact-us",
      name: "contact-us",
      component: LazyContactUs
    },
    {
      path: "/faq",
      name: "faq",
      component: LazyFaq
    },
    {
      path: "/home-about",
      name: "home-about",
      component: LazyHomeAbout
    },
    {
      path: "/impact-board",
      name: "impact-board",
      component: LazyImpactBoard,
      beforeEnter: (to, from, next) => {
        impactBoardMembersState.fetchMembers();
        next();
      }
    },
    {
      path: "/certificate/:verifyCode",
      name: "verify-certificate",
      component: LazyVerifyCertificate
    },
    {
      path: "*",
      component: LazyPageNotFound
    },
    {
      path: "/certificate/:verifyCode/print",
      name: "print-certificate",
      component: CertificateToPrint
    },
    {
      path: "/results",
      name: "results",
      component: LazySearchResults
    },
    {
      path: "/transparencia",
      name: "transparencia",
      component: LazyESic
    }
  ]
});

/**
 * DONT TOUCH IN SOURCE BELLOW!!
 */
const originalPush = VueRouter.prototype.push;
// @ts-ignore
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalPush.call(this, location, onResolve, onReject);
  }
  // @ts-ignore
  return originalPush.call(this, location).catch(() => noop());
};

const originalReplace = VueRouter.prototype.replace;
// @ts-ignore
VueRouter.prototype.replace = function replace(location, onResolve, onReject) {
  if (onResolve || onReject) {
    return originalReplace.call(this, location, onResolve, onReject);
  }
  // @ts-ignore
  return originalReplace.call(this, location).catch(() => noop());
};

export default router;
